import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "activity-package-formula"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("批量结束");

const _hoisted_6 = {
  class: "table-operation"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("查看");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("复制");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("提前结束");

const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = {
  key: 1,
  class: "record-empty"
};

const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "red",
    "font-size": "12px",
    "margin-top": "5px"
  }
}, "若不选择时间默认为立即结束", -1);

const _hoisted_16 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_17 = /*#__PURE__*/_createTextVNode("确定");

import { ref, reactive, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getVexTableProps } from '@/config';
import { getRedPacketList, removeActivity, endActivity, getProjectList } from '@/request';
import { ElMessage, ElMessageBox } from 'element-plus';
import SupplierModal from '../PreferentialPurchase/components/muti-supplier-modal.vue';
import ActivityEditRecordListModal from './components/ActivityEditRecordListModal.vue';
export default {
  name: 'index',

  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const activityStatus = [{
      label: '未开始',
      value: 1
    }, {
      label: '进行中',
      value: 2
    }, {
      label: '已结束',
      value: 3
    }];
    const form = reactive({
      activityName: '',
      activityStatus: '',
      activityPublisher: '',
      keyword: '',
      projectId: ''
    });
    const projectList = ref([]);

    function loadProjectList() {
      getProjectList().then(data => {
        projectList.value = Array.isArray(data) ? data : [];
      });
    }

    onMounted(() => {
      loadProjectList();
    });
    const table = ref();
    const hasSelection = ref(false);
    const supplierModal = reactive({
      visible: false,
      filterSupplierIds: ''
    });
    const recordModal = reactive({
      visible: false,
      row: {}
    });
    const endDialogVisible = ref(false);
    const endTimeRange = ref('');
    const endSelectedIds = ref([]);
    const tableOptions = getVexTableProps({
      loading: false,
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '活动ID',
        field: 'activityId'
      }, {
        title: '活动名称',
        field: 'activityName'
      }, {
        title: '活动状态',
        field: 'activityStatusName',
        width: '120px'
      }, {
        title: '关联项目',
        field: 'relatedProject',
        width: '140px',
        showOverflow: 'tooltip'
      }, {
        title: '活动类型',
        field: 'activityTypName',
        width: '140px'
      }, {
        title: '活动发起方',
        field: 'activityPublisher',
        showOverflow: 'tooltip',
        slots: {
          default: 'publisher'
        }
      }, {
        title: '活动时间',
        field: 'activityStartTime',
        slots: {
          default: 'time'
        }
      }, {
        title: '更新记录数',
        field: 'editRecordCount',
        width: '100px',
        align: 'center',
        slots: {
          default: 'editRecordCount'
        }
      }, {
        title: '操作',
        slots: {
          default: 'operation'
        },
        align: 'left',
        headerAlign: 'center',
        width: '230px'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getRedPacketList(_objectSpread(_objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize,
              activityType: 'TC'
            }, form), {}, {
              projectId: form.projectId || undefined
            })).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.activityList
              });
            });
          })
        }
      }
    });

    function endDisabledDate(time) {
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      return time.getTime() < now.getTime();
    }

    function handleSelectionChange() {
      const selectRows = table.value.getCheckboxRecords();
      hasSelection.value = !!selectRows.length;
    }

    function resetHandle() {
      Object.keys(form).forEach(key => {
        form[key] = '';
      });
      table.value.commitProxy('reload');
    }

    function reomveHandle(activityId) {
      ElMessageBox.confirm('确认删除该活动吗？', '提示').then(() => {
        removeActivity({
          activityId
        }).then(res => {
          const {
            success,
            msg
          } = res;

          if (success) {
            ElMessage.success(msg);
            table.value.commitProxy('query');
            return true;
          }

          ElMessage.error(msg);
          return false;
        });
      });
    }

    function endHandle(row) {
      endSelectedIds.value = [row.activityId];
      endTimeRange.value = '';
      endDialogVisible.value = true;
    }

    function activityActionHandle(pageType, activityId, activityStatus) {
      router.push({
        name: 'PackageFormulaActivityUpdate',
        query: {
          from: route.name,
          pageType,
          activityId,
          activityStatus
        }
      });
    }

    function openPublisherDialog(row) {
      supplierModal.filterSupplierIds = row.activityPublisherIds || '';
      supplierModal.visible = true;
    }

    function openRecordModal(row) {
      recordModal.row = row;
      recordModal.visible = true;
    }

    function batchEndActivity() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      endSelectedIds.value = selectRows.map(i => i.activityId);
      endTimeRange.value = '';
      endDialogVisible.value = true;
    }

    function confirmEndActivity() {
      const now = new Date();

      if (new Date(endTimeRange.value).getTime() < now.getTime()) {
        ElMessage.warning('结束时间不能小于当前时间');
        return;
      }

      const isBatch = endSelectedIds.value.length > 1;

      if (isBatch) {
        endActivity({}, {
          params: {
            activityIds: endSelectedIds.value.join(','),
            endTimeStr: endTimeRange.value,
            __repeat: true,
            __warn: true
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            endDialogVisible.value = false;
            table.value.commitProxy('reload');
          }
        });
      } else {
        endActivity({
          activityId: endSelectedIds.value[0],
          endTimeStr: endTimeRange.value
        }).then(res => {
          const {
            success,
            msg
          } = res;

          if (success) {
            ElMessage.success(msg);
            endDialogVisible.value = false;
            table.value.commitProxy('query');
            return true;
          }

          ElMessage.error(msg);
          return false;
        });
      }
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_link = _resolveComponent("el-link");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        inline: true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "活动名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.activityName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.activityName = $event),
            placeholder: "请输入活动名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "活动状态"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: form.activityStatus,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.activityStatus = $event),
            placeholder: "全部",
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(activityStatus, item => {
              return _createVNode(_component_el_option, {
                value: item.value,
                label: item.label,
                key: item.value
              }, null, 8, ["value", "label"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "活动发起方"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.activityPublisher,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.activityPublisher = $event),
            placeholder: "请输入活动发起方"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "项目名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: form.projectId,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.projectId = $event),
            placeholder: "请选择",
            clearable: "",
            filterable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.projectId,
                value: item.projectId,
                label: item.projectName
              }, null, 8, ["value", "label"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "活动主品编码/名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.keyword,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.keyword = $event),
            placeholder: "请输入活动主品编码/名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Search",
            onClick: _cache[5] || (_cache[5] = $event => table.value.commitProxy('reload'))
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            icon: "Refresh",
            onClick: resetHandle
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions), {
        onCheckboxChange: handleSelectionChange,
        onCheckboxAll: handleSelectionChange
      }), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[6] || (_cache[6] = $event => activityActionHandle('create'))
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: batchEndActivity
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        operation: _withCtx(({
          row
        }) => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: $event => activityActionHandle('view', row.activityId)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 2
        }, 1032, ["onClick"]), row.activityStatus === 1 || row.activityStatus === 2 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: $event => activityActionHandle('update', row.activityId, row.activityStatus)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          type: "primary",
          onClick: $event => activityActionHandle('copy', row.activityId),
          style: {
            "margin-left": "10px"
          }
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 2
        }, 1032, ["onClick"]), row.activityStatus === 1 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "danger",
          onClick: $event => reomveHandle(row.activityId)
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), row.activityStatus === 2 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          type: "danger",
          onClick: $event => endHandle(row)
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)])]),
        time: _withCtx(({
          row
        }) => [_createElementVNode("div", null, _toDisplayString(row.activityStartTime) + " - " + _toDisplayString(row.activityEndTime), 1)]),
        publisher: _withCtx(({
          row
        }) => [Number(row.activityPublisherCount) > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_link, {
          type: "primary",
          underline: false,
          onClick: $event => openPublisherDialog(row)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(row.activityPublisherCount), 1)]),
          _: 2
        }, 1032, ["onClick"])])) : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(row.activityPublisher), 1))]),
        editRecordCount: _withCtx(({
          row
        }) => [row.editRecordCount > 0 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          link: "",
          type: "primary",
          class: "record-link",
          onClick: $event => openRecordModal(row)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(row.editRecordCount), 1)]),
          _: 2
        }, 1032, ["onClick"])) : (_openBlock(), _createElementBlock("span", _hoisted_14, "0"))]),
        _: 1
      }, 16), _createVNode(SupplierModal, {
        modelValue: supplierModal.visible,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => supplierModal.visible = $event),
        filterSupplierIds: supplierModal.filterSupplierIds,
        checkType: "checkbox",
        viewOnly: true
      }, null, 8, ["modelValue", "filterSupplierIds"]), _createVNode(ActivityEditRecordListModal, {
        modelValue: recordModal.visible,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => recordModal.visible = $event),
        row: recordModal.row
      }, null, 8, ["modelValue", "row"]), _createVNode(_component_el_dialog, {
        modelValue: endDialogVisible.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => endDialogVisible.value = $event),
        title: "提前结束",
        width: "400px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = $event => endDialogVisible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_16]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirmEndActivity
        }, {
          default: _withCtx(() => [_hoisted_17]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "90px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "结束时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: endTimeRange.value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => endTimeRange.value = $event),
              type: "datetime",
              placeholder: "请选择结束时间",
              "value-format": "YYYY-MM-DD HH:mm:ss",
              "disabled-date": endDisabledDate
            }, null, 8, ["modelValue"]), _hoisted_15]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};